import { CoreSlider } from "@boi/components-core";
import { type SliderBaseProps, type SliderTooltipNotch } from "..";
import { useIsTooltipNotches } from "./useIsTooltipNotches.hook";
import { useSafeSliderNotches } from "./SafeSliderTooltipNotches";

type Params = Pick<
  SliderBaseProps,
  "value" | "minValue" | "maxValue" | "notches"
>;

export const useNotchTooltip = ({
  value,
  minValue = CoreSlider.DEFAULT_MIN_VALUE,
  maxValue = CoreSlider.DEFAULT_MAX_VALUE,
  notches,
}: Params): string | undefined => {
  if (!useIsTooltipNotches(notches)) return undefined;

  const safeNotches = useSafeSliderNotches(
    minValue,
    maxValue,
    notches
  ) as SliderTooltipNotch[];

  if (safeNotches[0] && value < safeNotches[0].startValue) return "";

  let bestTooltip = undefined;
  safeNotches.every((notch, index) => {
    if ((notch.startValue - 1) > value) {
      bestTooltip = safeNotches[index - 1]?.tooltip;
      return false;
    }
    return true;
  });

  return bestTooltip === undefined
    ? safeNotches[safeNotches.length - 1]?.tooltip
    : bestTooltip;
};
